<template>
  <MuiAlertBox
    title="Atenção ao local de postagem"
    type="info"
    :closeButton="false"
  >
    <p class="mui-alertbox__description">
      Você tem envios que devem ser postados separadamente na unidade da transportadora e no Melhor Ponto.
      <a href="javascript:;" @click.prevent="$emit('handle-action')">Saiba mais</a>.
    </p>
  </MuiAlertBox>
</template>

<script>
import MuiAlertBox from "commons/js/components/atoms/MuiAlertBox.vue";

export default {
  components: {
    MuiAlertBox
  }
}
</script>
